import Vue from "vue"
import VueGtag from "vue-gtag"

import config from "@/app.config"
import router from "@/router"

Vue.use(VueGtag, { config: { ...config.plugins.gtag } }, router)
